import { useEffect } from "react";
import { createPortal } from "react-dom";
import "./style.css";

export default function DialogShell({
  children,
  className = "",
  backdropClassName = "",
  labelledBy,
  onClose,
  role = "dialog",
  modal = true,
  lockScroll = true,
}) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    const previousOverflow = document.body.style.overflow;
    if (lockScroll) document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      if (lockScroll) document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [lockScroll, onClose]);

  return createPortal(
    <div className={`admin-dialog-backdrop ${backdropClassName}`.trim()} onMouseDown={(event) => {
      if (event.target === event.currentTarget) onClose?.();
    }}>
      <section
        className={`admin-dialog ${className}`.trim()}
        role={role}
        aria-modal={modal ? "true" : undefined}
        aria-labelledby={labelledBy}
      >
        {children}
      </section>
    </div>,
    document.body,
  );
}
